import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect, lazy, Suspense } from "react";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import PreviousResult from "@/pages/PreviousResult";
import CommonNumber from "@/pages/CommonNumber";
import NotFound from "@/pages/NotFound";
import { AuthProvider } from "@/contexts/AuthContext";

// Lazy load secondary pages so the initial mobile bundle only ships Home + PreviousResult + CommonNumber
const Guide = lazy(() => import("@/pages/Guide"));
const About = lazy(() => import("@/pages/About"));
const Contact = lazy(() => import("@/pages/Contact"));
const PrivacyPolicy = lazy(() => import("@/pages/PrivacyPolicy"));
const Terms = lazy(() => import("@/pages/Terms"));
const Disclaimer = lazy(() => import("@/pages/Disclaimer"));
const AdminLogin = lazy(() => import("@/pages/AdminLogin"));
const AdminDashboard = lazy(() => import("@/pages/AdminDashboard"));

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function PublicRoutes() {
  return (
    <Layout>
      <Suspense fallback={<div className="h-24" aria-hidden />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/previous-result" element={<PreviousResult />} />
          <Route path="/previous-result/" element={<PreviousResult />} />
          <Route path="/common-number" element={<CommonNumber />} />
          <Route path="/common-number/" element={<CommonNumber />} />
          <Route path="/juwai-teer-guide" element={<Guide />} />
          <Route path="/juwai-teer-guide/" element={<Guide />} />
          <Route path="/about" element={<About />} />
          <Route path="/about/" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/contact/" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/privacy-policy/" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/terms/" element={<Terms />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/disclaimer/" element={<Disclaimer />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Suspense fallback={<div className="h-24" aria-hidden />}>
            <Routes>
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/*" element={<PublicRoutes />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
